/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function EditGridTemplate(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'EditGridTemplate',
      'aria-hidden': true,
      focusable: false,
      width:  20 * scale,
      height: 20 * scale,
      viewBox: '0 0 20 20',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('g', {"clipPath":"url(#wf-svg-EditGridTemplate-__a)","fillRule":"evenodd","clipRule":"evenodd","fill":"currentColor"},createElement('path', {"opacity":".8","d":"M2 2h7v7H2zm9 0h7v5.784a3 3 0 0 0-2.621.837L15 9h-4zm2 9h-2v2zm-4 4-1 1v2H2v-7h7zm7 3 2-2v2z"}),createElement('path', {"d":"M16.793 9.707a1 1 0 0 1 1.414 0l1.086 1.086a1 1 0 0 1 0 1.414L18.28 13.22l-2.5-2.5zM14.72 11.78l2.5 2.5L12.5 19H10v-2.5z"})),createElement('defs', null,createElement('clipPath', {"id":"wf-svg-EditGridTemplate-__a"},createElement('path', {"fill":"#fff","d":"M0 0h20v20H0z"}))))
}
